import axios from "axios";
let actions = {
    /**
     * @returns {Promise<Array>}
     */
    getGroups() {
        console.log("Getting groups");
        return new Promise((resolve, reject) => {
            axios.get("/group")
                .then(data => {
                    console.log(data);
                    let body = data.data.object;
                    resolve(body)
                })
                .catch(err => {
                    let response = err.response;
                    console.log(response);
                    reject()
                })
        })
    },
    /**
     * 
     * @param {String} id 
     */
    getGroup(id) {
        return new Promise((resolve, reject) => {
            actions.getGroups()
                .then(data => {
                    data.forEach(group => {
                        if (String(group._id) == String(id)) {
                            resolve(group)
                        }
                    })
                    reject(null);
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
    /**
     * 
     * @param {String} id 
     */
    removeGroup(id) {
        return new Promise((resolve, reject) => {
            axios.delete("/group", {
                data: {
                    _id: id
                }
            })
                .then(data => {
                    resolve();
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
    editGroup(id, name) {
        return new Promise((resolve, reject) => {
            axios.put("/group", {
                _id: id,
                name: name
            })
                .then(data => {
                    resolve(data.data.object);
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
    addGroup(name) {
        return new Promise((resolve, reject) => {
            if (String(name).trim() == "") {
                reject("Invalid name for group.");
                return;
            }
            axios.post("/group", {
                name: name
            })
                .then(data => {
                    resolve(data.data.object);
                })
                .catch(err => {
                    reject(err);
                })
        })
    }
}
export default actions;